import { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { BsCalendarDate } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { fetchRace } from "../../../../redux/getReducer/getCard";

import TodayRaceCard from "../../../../pages/TodayRaceCard";
import Result from "../../Components/Result";
import RaceCardDetail from "../../../../pages/RaceCardDetail";
import { useTranslation } from "react-i18next";

export default function HomeTabs({ raceCardData }) {

const { t } = useTranslation();

  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Live");

  // Use useParams to extract id and date from URL path segments
  const { id } = useParams();
 
  const hash = window.location.hash; // Part after #
  const decodedDate = binaryToDate(hash.replace("#", ""));


    const location = useLocation();
  const id2 = location.search.slice(1);



  console.log(id2,"id2 --------------")
  console.log(id,"id --------------")

  // const { data: racecard, status } = useSelector((state) => state.racecard);
  const { data: Card } = useSelector((state) => state.Card);
  function binaryToDate(binaryString) {
    const timestamp = parseInt(binaryString, 2); // convert binary to decimal
    return new Date(timestamp); // convert to Date object
  }

  useEffect(() => {
    if (id && decodedDate) {
      dispatch(fetchRace({ calenderid: id, convertedDate: decodedDate }));
    }
  }, [id, dispatch]);

  const apiCheck = Card[0];
  useEffect(() => {
    if (apiCheck?.RaceCourseData?.[0]?.Day) {
      setActiveTab("Racelisting");
    }
  }, [apiCheck?.RaceCourseData?.[0]?.Day]);

  console.log(location.pathname + location.search, "location");

  const fullPath = `/racedetail?${id2}`;
    console.log(fullPath, "fullPath");


  return (
    <>
      {location.pathname + location.search === fullPath ? (
        <RaceCardDetail />
      ) : (
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          id="uncontrolled-tab-example"
          className="mb-3 sha-stats"
        >
         <Tab eventKey="Live" title={t("LiveResult")}>
            <Result />
          </Tab>

          <Tab
            eventKey="Racelisting"
            title={
              <>
                <BsCalendarDate style={{ marginRight: "5px" }} />
                {apiCheck?.RaceCourseData?.[0]?.Day
                  ? new Date(apiCheck.RaceCourseData[0].Day).toDateString()
                  : " "}
              </>
            }
            disabled={!apiCheck?.RaceCourseData?.[0]?.Day}
          >
            <TodayRaceCard />
            {/* <TodayRaceCard /> */}
          </Tab>
        </Tabs>
      )}
    </>
  );
}
